import { useState, useEffect } from "react";
import DataService from "../../../../../Service";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Checkbox } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import CustomInput from "../../../../../Components/CustomInput";
import Loader from "../../../../../Components/Loader";
import { makeStyles } from "@material-ui/core/styles";
import CoachingProgramModal from "./CoachingProgramModal";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
  },
  formTab: {
    "& h2": {
      fontSize: "1.2em",
    },
  },
  backButton: {
    marginRight: theme.spacing(2),
  },
  wrapper: {
    margin: "3%",
  },
  detail: {
    padding: "3%",
    backgroundColor: "#fff",
    boxShadow: "0px 3px 6px #232323",
  },
  paper: {
    // padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    "& span:last-child": {
      fontSize: "13px",
      color: "#303030",
    },
    "& svg": {
      width: "1.5em",
      height: "1.5em",
    },
  },
  bottomBar: {
    boxShadow: "0px 0px 6px #232323",
    padding: "15px",
    textAlign: "center",
    margin: "0 -24px",
    marginTop: "10px",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 1075,
    backgroundColor: "#fff",
  },
  // descriptionFont: {
  //     fontSize: '15px'
  // },
  buttonCss: {
    textTransform: "capitalize",
    width: "128px",
    height: "40px",
    fontWeight: 900,
  },
}));

const ClientPolicies = (props) => {
  const { currentSelection, setTabIndex, setStepperData, setHeaderType } =
    props;
  const classes = useStyles();
  const [isNew, setIsNew] = useState(false);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);

  const extension_policy = [
    {
      name: "None permitted",
      value: false,
    },
    {
      name: "Permitted subject to Line manager approval",
      value: false,
    },
    {
      name: "Permitted subject to HR approval",
      value: false,
    },
    {
      name: "Permitted subject to Program manager approval",
      value: false,
    },
    {
      name: "Extension policy other",
      value: false,
      text: "",
    },
    {
      name: "Extension policy notes",
      value: false,
      text: "",
    },
  ];
  const pgm_cancellation_terms = [
    {
      name: "can be cancelled at no cost prior to the program starting",
      value: false,
    },
    {
      name: "can be cancelled between payment tranches with no further cost incurred",
      value: false,
    },
    {
      name: "can be cancelled up to midpoint and remaining sessions held as credit for 6 months",
      value: false,
    },
    {
      name: "can be cancelled after midpoint and no refund will be applicable",
      value: false,
    },
    {
      name: "can be cancelled after midpoint and remaining sessions held as credit for 6 months",
      value: false,
    },
    {
      name: "program cancellation terms other",
      value: false,
      text: "",
    },
    {
      name: "program cancellation term notes",
      value: false,
      text: "",
    },
    {
      name: "if there are no sessions outstanding, no additional delivery charge shall be made",
      value: false,
    },
    {
      name: "if a coach is found not to be suitable after the first session, a replacement coach will be identified, at no additional cost",
      value: false,
    },
    {
      name: "if a coach is unavailable to complete an assignment a replacement coach will be identified, at no additional cost",
      value: false,
    },
  ];
  const session_cancellation_terms = [
    {
      name: "more than 48 hrs notice the client will not be charged and the session will be rearranged",
      value: false,
    },
    {
      name: "less than 48 hrs notice - client can be charged for another session or have a session deducted of the program, unless it is the final session",
      value: false,
    },
    {
      name: "session cancellation terms other",
      value: false,
      text: "",
    },
    {
      name: "session cancellation term notes",
      value: false,
      text: "",
    },
  ];
  const cancellation_terms_360 = [
    {
      name: "more than 48 hrs notice the client will not be charged and the session will be rearranged",
      value: false,
    },
    {
      name: "less than 48 hrs notice the client can be charged for the pro rata rate of the call based on the number of stakeholders",
      value: false,
    },
    {
      name: "a no show the client can be charged for the pro rata rate of the call based on the number of stakeholders",
      value: false,
    },
    {
      name: "360 session cancellation term other",
      value: false,
    },
    {
      name: "360 session cancellation term notes",
      value: false,
    },
  ];

  const [clientPoliciesData, setClientPoliciesData] = useState({
    extension_policy: { data: [...extension_policy] },
    pgm_cancellation_terms: { data: [...pgm_cancellation_terms] },
    session_cancellation_terms: { data: [...session_cancellation_terms] },
    cancellation_terms_360: { data: [...cancellation_terms_360] },
  });

  useEffect(() => {
    setStepperData("Terms and Policies");
    setHeaderType("");
    fetch();
  }, []);

  const handleClientPoliciesChange = (key, index, value) => {
    const data = { ...clientPoliciesData };
    data[key]["data"][index] = { ...value };
    setClientPoliciesData((oldValue) => ({ ...oldValue, ...data }));
  };

  const handleModal = (boolValue) => {
    setModal(boolValue);
  };

  const fetch = () => {
    const params =
      props?.action == "editMaster"
        ? { master_template_id: currentSelection?.id, user_type: "client" }
        : { programme_id: currentSelection?.id, user_type: "client" };
    const apiUrl =
      props?.action == "editMaster" ? "terms_condition" : "terms_policies";
    setLoading(true);
    DataService.getData(params, apiUrl)
      .then((res) => {
        if (res?.success) {
          if (
            res &&
            res?.cancellation_terms_360 !== null &&
            res?.extension_policy !== null &&
            res?.pgm_cancellation_terms !== null &&
            res?.session_cancellation_terms !== null
          ) {
            const res_program = res.pgm_cancellation_terms;
            const index1 = res.pgm_cancellation_terms.data.findIndex(
              (e) =>
                e.name ===
                "can be cancelled up to midpoint and if invoiced and paid for, remaining sessions will be repaid to Acuity Coaching"
            );
            const index2 = res.pgm_cancellation_terms.data.findIndex(
              (e) =>
                e.name ===
                "can be cancelled after midpoint and if invoiced and paid for, remaining sessions will be repaid to Acuity Coaching"
            );
            if (index1 !== -1) {
              res_program.data[index1].name =
                "can be cancelled up to midpoint and remaining sessions held as credit for 6 months";
            }
            if (index2 !== -1) {
              res_program.data[index2].name =
                "can be cancelled after midpoint and remaining sessions held as credit for 6 months";
            }
            setClientPoliciesData({ ...res });
            setIsNew(false);
          } else {
            setIsNew(true);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let obj = {
      programme_id: currentSelection?.id,
      user_type: "client",
      ...clientPoliciesData,
    };
    if (isNew) {
      const createApiUrl =
        props?.action == "editMaster"
          ? "create_terms_policies"
          : "terms_policies";
      setNextButtonLoading(true);
      DataService.createData(obj, createApiUrl)
        .then((res) => {
          if (res?.success) {
            fetch();
            setTabIndex(1);
            window.document.getElementsByClassName(
              "MuiDrawer-paperAnchorRight"
            )[0].scrollTop = 0;
            setNextButtonLoading(false);
            handleModal(true);
          }
        })
        .catch((error) => {
          setNextButtonLoading(false);
        });
    } else {
      const updateApiUrl =
        props?.action == "editMaster"
          ? "terms_policies"
          : "update_terms_policies";
      setNextButtonLoading(true);
      DataService.updateData(obj, "", updateApiUrl)
        .then((res) => {
          if (res?.success) {
            fetch();
            setTabIndex(1);
            window.document.getElementsByClassName(
              "MuiDrawer-paperAnchorRight"
            )[0].scrollTop = 0;
            setNextButtonLoading(false);
            handleModal(true);
          }
        })
        .catch((error) => {
          setNextButtonLoading(false);
        });
    }
  };

  return (
    <>
      <form style={{ marginLeft: "-135px" }} onSubmit={handleSubmit}>
        <Container style={{ margin: "16px", width: "100%" }} maxWidth="xl">
          {loading && <Loader />}
          <Grid>
            <Grid
              style={{ padding: "10px 0px 0px 80px" }}
              container
              spacing={2}
            >
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Extension policy
              </Typography>
            </Grid>
            <Grid container style={{ padding: "5px 70px" }}>
              {clientPoliciesData.extension_policy.data.map((item, index) => (
                <Grid item xs={12} container>
                  <Grid style={{minWidth:"14rem"}}>
                    <FormControlLabel
                      value={item.name}
                      control={
                        <Checkbox
                          name={item.name}
                          checked={Boolean(item?.value)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography
                          variant="h2"
                          style={{ textTransform: "none", fontSize: "1rem" }}
                        >
                          {item.name}
                        </Typography>
                      }
                      onChange={(event) =>
                        handleClientPoliciesChange(
                          "extension_policy",
                          index,
                          event.target.checked
                            ? { ...item, value: event.target.checked }
                            : { ...extension_policy[index] }
                        )
                      }
                      className={classes.paper}
                    />
                  </Grid>

                  {[
                    "Permitted subject to Line manager approval",
                    "Permitted subject to Program manager approval",
                  ].includes(item.name) &&
                    item?.value && (
                      <Grid item xs={12} container>
                        <Grid item xs={1} style={{ margin: "0 2.5rem" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={"requirements"}
                                color="primary"
                                checked={Boolean(item.requirements)}
                              />
                            }
                            onChange={(event) =>
                              handleClientPoliciesChange(
                                "extension_policy",
                                index,
                                { ...item, requirements: event.target.checked }
                              )
                            }
                            label={
                              <Typography variant="h2" style={{ textTransform: "none", fontSize: "1rem" }}>Requirements</Typography>
                            }
                          />
                        </Grid>
                        <Grid xs={5}>
                          {item.requirements ? (
                            <CustomInput
                              style={{ paddingBottom: "16px" }}
                              variant="outlined"
                              name={item.name + " value"}
                              multiline
                              rows={4}
                              parentcall={(value, name) => {
                                handleClientPoliciesChange(
                                  "extension_policy",
                                  index,
                                  { ...item, text: value }
                                );
                              }}
                              value={item?.text}
                              InputLabelProps={{ shrink: true }}
                            />
                          ) : null}
                        </Grid>
                      </Grid>
                    )}
                  {[
                    "Extension policy other",
                    "Extension policy notes",
                  ].includes(item.name) &&
                    item?.value && (
                      <Grid item xs={5}>
                        <CustomInput
                          variant="outlined"
                          name={item.name + " value"}
                          parentcall={(value, name) => {
                            handleClientPoliciesChange(
                              "extension_policy",
                              index,
                              { ...item, text: value }
                            );
                          }}
                          multiline
                          rows={4}
                          value={item?.text}
                          InputLabelProps={{ shrink: true }}
                          style={{ paddingBottom: "16px" }}
                        />
                      </Grid>
                    )}
                </Grid>
              ))}
            </Grid>
            <Divider style={{ width: "80%" }} />

            {/* Program Cancellation Terms */}
            <Grid
              style={{ padding: "10px 0px 0px 80px" }}
              container
              spacing={2}
            >
            
              <Typography variant="subtitle1" style={{ fontWeight: "bold", textTransform: "none", fontSize: "1rem" }}>
                Program cancellation terms
              </Typography>
            </Grid>
            {clientPoliciesData.pgm_cancellation_terms.data.map(
              (item, index) => {
                return (
                  <Grid container style={{ padding: "5px 70px" }}>
                    <Grid style={{minWidth:"19.75rem"}}>
                      <FormControlLabel
                        label={
                          <Typography variant="h2" style={{ textTransform: "none", fontSize: "1rem" }}>{item.name}</Typography>
                        }
                        className={classes.paper}
                        control={
                          <Checkbox
                            name={item.name}
                            checked={Boolean(item?.value)}
                            color="primary"
                          />
                        }
                        onChange={(event) =>
                          handleClientPoliciesChange(
                            "pgm_cancellation_terms",
                            index,
                            event.target.checked
                              ? { ...item, value: event.target.checked }
                              : { ...pgm_cancellation_terms[index] }
                          )
                        }
                      />
                    </Grid>
                    {[
                      "program cancellation terms other",
                      "program cancellation term notes",
                    ].includes(item.name) &&
                      item?.value && (
                        <Grid item xs={5}>
                          <CustomInput
                            variant="outlined"
                            name={item.name + " value"}
                            parentcall={(value, name) => {
                              handleClientPoliciesChange(
                                "pgm_cancellation_terms",
                                index,
                                { ...item, text: value }
                              );
                            }}
                            multiline
                            rows={4}
                            value={item.text}
                            InputLabelProps={{ shrink: true }}
                            style={{ paddingBottom: "16px" }}
                          />
                        </Grid>
                      )}
                    {item?.name === "program cancellation term notes" && (
                      <Grid item xs={12} style={{ margin: "28px auto" }}>
                        {" "}
                        <Typography variant="h2" style={{ textTransform: "none", fontSize: "1rem" }}>
                          In addition, please note:
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                );
              }
            )}

            <Divider style={{ width: "80%" }} />

            {/* Session Cancellation Terms */}
            <Grid
              style={{ padding: "10px 0px 0px 80px" }}
              container
              spacing={2}
            >
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Session cancellation terms
              </Typography>
            </Grid>
            {clientPoliciesData.session_cancellation_terms.data.map(
              (item, index) => {
                return (
                  <Grid container style={{ padding: "5px 70px" }}>
                    <Grid style={{minWidth:"19rem"}}>
                      <FormControlLabel
                        label={
                          <Typography variant="h2" style={{ textTransform: "none", fontSize: "1rem" }}>{item.name}</Typography>
                        }
                        className={classes.paper}
                        control={
                          <Checkbox
                            name={item.name}
                            checked={Boolean(item?.value)}
                            color="primary"
                          />
                        }
                        onChange={(event) =>
                          handleClientPoliciesChange(
                            "session_cancellation_terms",
                            index,
                            event.target.checked
                              ? { ...item, value: event.target.checked }
                              : { ...session_cancellation_terms[index] }
                          )
                        }
                      />
                    </Grid>
                    {[
                      "session cancellation terms other",
                      "session cancellation term notes",
                    ].includes(item.name) &&
                      item?.value && (
                        <Grid item xs={5}>
                          <CustomInput
                            variant="outlined"
                            name={item.name + " value"}
                            parentcall={(value, name) => {
                              handleClientPoliciesChange(
                                "session_cancellation_terms",
                                index,
                                { ...item, text: value }
                              );
                            }}
                            multiline
                            rows={4}
                            value={item?.text}
                            InputLabelProps={{ shrink: true }}
                            style={{ paddingBottom: "16px" }}
                          />
                        </Grid>
                      )}
                  </Grid>
                );
              }
            )}
            <Grid container style={{ padding: "5px 70px" }}>
              <Grid item xs={12} style={{ marginBottom: "20px" }}>
                <Typography variant="h2" style={{ textTransform: "none", fontSize: "1rem" }}>In addition, please note:</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography component="span" variant="h2" style={{ textTransform: "none", fontSize: "1rem", fontWeight :"bold" }}>
                  {/* <strong>
                    <p className={classes.descriptionFont}> */}
                      Session cancellations are not automatically charged for
                      and is dependent on whether the coach would like to charge
                      for the time
                    {/* </p>
                  </strong> */}
                </Typography>
              </Grid>
            </Grid>
            <Divider style={{ width: "80%" }} />

            {/* 360 Cancellation Terms */}
            <Grid
              style={{ padding: "10px 0px 0px 80px" }}
              container
              spacing={2}
            >
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                360 cancellation terms
              </Typography>
            </Grid>
            {clientPoliciesData.cancellation_terms_360.data.map(
              (item, index) => {
                return (
                  <Grid container style={{ padding: "5px 70px" }}>
                    <Grid style={{minWidth:"19rem"}}>
                      <FormControlLabel
                        label={
                          <Typography variant="h2" style={{ textTransform: "none", fontSize: "1rem" }}>{item.name}</Typography>
                        }
                        className={classes.paper}
                        control={
                          <Checkbox
                            name={item.name}
                            checked={Boolean(item?.value)}
                            color="primary"
                          />
                        }
                        onChange={(event) =>
                          handleClientPoliciesChange(
                            "cancellation_terms_360",
                            index,
                            event.target.checked
                              ? { ...item, value: event.target.checked }
                              : { ...cancellation_terms_360[index] }
                          )
                        }
                      />
                    </Grid>
                    {[
                      "360 session cancellation term other",
                      "360 session cancellation term notes",
                    ].includes(item.name) &&
                      item?.value && (
                        <Grid item xs={5}>
                          <CustomInput
                            variant="outlined"
                            name={item.name + " value"}
                            parentcall={(value, name) => {
                              handleClientPoliciesChange(
                                "cancellation_terms_360",
                                index,
                                { ...item, text: value }
                              );
                            }}
                            multiline
                            rows={4}
                            value={item?.text}
                            InputLabelProps={{ shrink: true }}
                            style={{ paddingBottom: "16px" }}
                          />
                        </Grid>
                      )}
                  </Grid>
                );
              }
            )}
            <Grid container style={{ padding: "25px 70px" }}>
              <Grid
                item
                xs={12}
                style={{ fontSize: "15px", marginBottom: "28px" }}
              >
                <Typography variant="h2" style={{ textTransform: "none", fontSize: "1rem" }}>In addition, please note:</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography component="span" variant="h2" style={{ textTransform: "none", fontSize: "1rem", fontWeight :"bold" }}>
                  {/* <strong>
                    <p className={classes.descriptionFont}> */}
                      360 Session cancellations are not automatically charged
                      for and is dependent on whether the coach would like to
                      charge for the time
                    {/* </p>
                  </strong> */}
                </Typography>
              </Grid>
            </Grid>
            <Divider style={{ width: "80%" }} />
            {modal && (
              <CoachingProgramModal
                isOpen={modal}
                onClose={() => {
                  handleModal(false);
                }}
              />
            )}
          </Grid>
        </Container>
        <div className={classes.bottomBar}>
          <Button
            onClick={() => props.handleClose()}
            className={classes.buttonCss}
            style={{ marginRight: "10px" }}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={classes.buttonCss}
            type="submit"
            disabled={nextButtonLoading}
            variant="contained"
            color="secondary"
          >
            Next
          </Button>
        </div>
      </form>
    </>
  );
};
export default ClientPolicies;
